import { useAppSearchParams } from "@/routing/navigation";

export default function useSubuserMode() {
  return useAppSearchParams().has("subuser");
}
